import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Address } from 'src/@core/interfaces/address.model';
import { AppService } from 'src/@core/services/app.service';

@Component({
  selector: 'hour4u-admin-book-marketplace-services',
  templateUrl: './book-marketplace-services.component.html',
  styleUrls: ['./book-marketplace-services.component.scss']
})
export class BookMarketplaceServicesComponent implements OnInit {
  isLoading: boolean = false;
  marketPlaceServiceForm: FormGroup;
  addressObj: Address = {};
  times = this.generateTimeSlots();
  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date >= today;
  };
  profile = this.appService.getCurrentAccount();
  isUserLogin: boolean = false;
  isOtpAuthRequired: boolean = false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '0',
  };
  otp: string = "";
  isButtonDisabled: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<BookMarketplaceServicesComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedData: any,
    private _fb: FormBuilder,
    private appService: AppService
  ) { }

  ngOnInit() {
    console.log(this.profile, !this.profile)

    if (this.profile && this.profile.user_details) {
      this.isUserLogin = true;
    } else {
      this.isUserLogin = false;
    }

    this.marketPlaceServiceForm = this._fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, this.emailOrPhoneValidator]],
      bookingDate: ['', [Validators.required]],
      serviceBookingLocation: ['', [Validators.required]],
      timeFrom: ['', [Validators.required]],
      quantity: ['', [Validators.required]],
      perQuantityCost: ['', [Validators.required]],
      totalCost: ['', [Validators.required]]
    });
    console.log(this.selectedData);

    if (this.selectedData.service.pricingType == 'VARIABLE') {
      this.marketPlaceServiceForm.controls['perQuantityCost'].setValue(this.selectedData.service.variableRateCard.totalAmount);
      this.marketPlaceServiceForm.controls['perQuantityCost'].updateValueAndValidity();
    }

    if (this.selectedData.service.pricingType == 'FIXED') {
      this.marketPlaceServiceForm.controls['perQuantityCost'].setValue(this.selectedData.service.fixedRateCard.totalAmount);
      this.marketPlaceServiceForm.controls['perQuantityCost'].updateValueAndValidity();
    }
  }

  emailOrPhoneValidator(control: AbstractControl): { [key: string]: any; } | null {
    const value = control.value;
    if (!value) {
      return null; // let required validator handle empty values
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const phonePattern = /^\d{10}$/; // Adjust the phone pattern as needed

    const isValidEmail = emailPattern.test(value);
    const isValidPhone = phonePattern.test(value);

    if (!isValidEmail && !isValidPhone) {
      return { invalidEmailOrPhone: true };
    }
    return null;
  }

  submit() {
    this.isButtonDisabled = true;
    if (!this.marketPlaceServiceForm.valid) {
      this.marketPlaceServiceForm.markAllAsTouched();
      this.isButtonDisabled = false;
      return;
    } else {
      if (this.isUserLogin) {
        this.bookService();
      } else {
        if (!this.isOtpAuthRequired) {
          this.sendOTP();
        } else {
          if (this.otp && this.otp.length == 6) {
            this.bookService();
          } else {
            this.isButtonDisabled = false;
          }
        }
      }
    }
  }

  goBack() {
    this.isOtpAuthRequired = false;
  }

  sendOTP() {
    console.log("Otp send")
    this.isOtpAuthRequired = true;
    this.isButtonDisabled = false;
  }

  resendOtp() {
    this.sendOTP();
  }

  bookService() {
    this.isButtonDisabled = false;
    console.log("book")
  }

  // set searched Address
  setAddress(data) {
    console.log(data)
    let location = {
      latitude: data.latitude,
      longitude: data.longitude,
      zip: data.zip,
      country: data.country,
      region: data.region,
      city: data.city,
      address: data.address,
      placeId: data.placeId
    }
    this.marketPlaceServiceForm.controls['serviceBookingLocation'].setValue(location);
    this.marketPlaceServiceForm.controls['serviceBookingLocation'].updateValueAndValidity();
  }

  //check for valid address
  onAddressValidityChanged(isValid: boolean): void {
  }

  generateTimeSlots(selectedStartTime?: string, selectedEndTime?: string): {
    timeDifference: string; display: string, value: string
  }[] {
    const times: {
      timeDifference: string; display: string, value: string
    }[] = [];

    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hour12 = ('0' + (h % 12 || 12)).slice(-2); // Convert 0 to 12 for 12-hour format
        const hour24 = ('0' + h).slice(-2); // 24-hour format
        const minute = ('0' + m).slice(-2);
        const period = h < 12 ? 'AM' : 'PM';

        const displayFormat = `${hour12}:${minute} ${period}`;
        const valueFormat = `${hour24}:${minute}`;

        times.push({
          display: displayFormat, value: valueFormat,
          timeDifference: ''
        });
      }
    }
    times.forEach(time => {
      // Calculate time difference for each time option
      // ... calculate time difference based on your logic
      time.timeDifference = '';// assign the calculated time difference
    });
    return times;
  }

  rateChange() {
    // if (this.selectedData.service.pricingType == 'VARIABLE') {
    //   this.marketPlaceServiceForm.controls['totalCost'].setValue( this.marketPlaceServiceForm.controls['perQuantityCost'].value * this.marketPlaceServiceForm.controls['quantity'].value);
    //   this.marketPlaceServiceForm.controls['totalCost'].updateValueAndValidity();
    // }

    // if (this.selectedData.service.pricingType == 'FIXED') {
    this.marketPlaceServiceForm.controls['totalCost'].setValue(this.marketPlaceServiceForm.controls['perQuantityCost'].value * this.marketPlaceServiceForm.controls['quantity'].value);
    this.marketPlaceServiceForm.controls['totalCost'].updateValueAndValidity();
    // }
  }

  onOtpChange(event: any) {
    this.otp = event;
  }
}
